import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import extractDialogProps from 'components/extractDialogProps';

export default function ConfirmDialog(props) {
  const [dialogProps] = extractDialogProps(props);
  const {
      message,
      handleClose
  } = props;

  return (
    <div>
      <Dialog
        {...dialogProps}
        aria-describedby="information-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="information-dialog-description">
          {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            確認
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}